module.exports = __webpack_public_path__ + "img/globe_blue.d0874db2.svg";